import React from 'react';

export interface MenuItem {
  label?: string;
  shortcut?: string;
  onClick?: () => void;
  disabled?: boolean;
  submenu?: MenuItem[];
  divider?: boolean;
}

interface MenuItemProps {
  item: MenuItem;
  level?: number;
}

const MenuItemComponent: React.FC<MenuItemProps> = ({ item, level = 0 }) => {
  if (item.divider) {
    return <div style={{ borderTop: '1px solid #444', margin: '4px 0' }} />;
  }
  return (
    <div
      className={`dropdown-item${item.disabled ? ' disabled' : ''}`}
      onClick={item.disabled ? undefined : item.onClick}
      style={{ opacity: item.disabled ? 0.5 : 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}
    >
      <span style={{ display: 'flex', alignItems: 'center' }}>
        {item.label}
        {item.submenu && <span style={{ marginLeft: 8 }}>{'>'}</span>}
      </span>
      {item.shortcut && <span style={{ color: '#888', marginLeft: 16, fontSize: 12 }}>{item.shortcut}</span>}
      {/* Alt menü burada render edilmeyecek, Menu componenti ile yönetilecek */}
    </div>
  );
};

export default MenuItemComponent; 